import { updateObject } from "../../shared";
import { globalSystemConstants } from "../../constants";

const {
  SPINNER_ACTIVATE,
  SPINNER_DIACTIVATE,
  OVERLAY_ACTIVATE,
  OVERLAY_DIACTIVATE,
  DOWNLOAD_SPINNER_ACTIVATE,
  DOWNLOAD_SPINNER_DIACTIVATE,
  LOADING_BUTTON_SPINNER_ACTIVATE,
  LOADING_BUTTON_SPINNER_DEACTIVATE,
  TOTAL_COUNT,
} = globalSystemConstants;

const initialState = {
  spinnerActions: [],
  isSpinnerActivate: false,
  isOverlayActivate: false,
  showDownloadProgress: false,
  loadingButton: false,
};

// default reducer i.e. ux manupilation
export const system = (state = initialState, action) => {
  switch (action.type) {
    case SPINNER_ACTIVATE:
      const actionsArr = [...state.spinnerActions];
      actionsArr.push(action.data);
      return updateObject(state, {
        spinnerActions: actionsArr,
        isSpinnerActivate: true,
      });
    case SPINNER_DIACTIVATE:
      const updatedSpinnerActions = state.spinnerActions.filter(
        (f) => f !== action.data
      );
      return updateObject(state, {
        spinnerActions: updatedSpinnerActions,
        isSpinnerActivate: updatedSpinnerActions.length > 0,
      });
    case OVERLAY_ACTIVATE:
      return updateObject(state, {
        isOverlayActivate: true,
      });
    case OVERLAY_DIACTIVATE:
      return updateObject(state, {
        isOverlayActivate: false,
      });
    case DOWNLOAD_SPINNER_ACTIVATE:
      return updateObject(state, {
        isSpinnerActivate: true,
        showDownloadProgress: true,
      });
    case DOWNLOAD_SPINNER_DIACTIVATE:
      return updateObject(state, {
        isSpinnerActivate: false,
        showDownloadProgress: false,
      });
    case LOADING_BUTTON_SPINNER_ACTIVATE:
      return updateObject(state, {
        loadingButton: true,
      });
    case LOADING_BUTTON_SPINNER_DEACTIVATE:
      return updateObject(state, {
        loadingButton: false,
      });
    case TOTAL_COUNT:
      return updateObject(state, {
        totalCount: action.data?.total || 0,
      });
    default:
      return state;
  }
};
